export function routerBeforeEachFunc (to, from, next) {
    // 这里可以做页面拦截，很多后台系统中也非常喜欢在这里面做权限处理
    // if (to.path) {
    //     _hmt.push(['_trackPageview', to.fullPath]);
    // }
    // if (to.path === '/zhongzheng' || !JSON.parse(window.localStorage.getItem('isToubaoju'))) {
    //     document.title = '全国PETCT/MR在线预约平台';
    // }

    // if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    //     let loginInfo = window.localStorage.getItem("loginUserInfo")
    //     if (loginInfo&&loginInfo != 'undefined') { // 判断该路由是否需要登录权限
    //         next()
    //     } else {
    //         next({
    //             path: '/',
    //             query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //         })
    //     }
    // } else {
    //     next();
    // }
    next()
}
